import { TFormValues, TRevokeFormValues } from './types';

export const initialFormValues: TFormValues = {
  phone: '',
  email: '',
  financialServices: false,
  financialServicesClientType: null,
  cardAccess: false,
  businessRelationship: false,
  businessRelationshipClientType: null,
  creditBureauData: false,
  atLeastOneCheckbox: false,
};

export const initialRevokeFormValues: TRevokeFormValues = {
  ...initialFormValues,
  otherReasonCheckbox: false,
  otherReason: null,
};

export const fieldsWithoutTouch = [
  'cardAccess',
  'businessRelationship',
  'businessRelationshipClientType',
  'creditBureauData',
] as const;

export const revokeFieldsWithoutTouch = [...fieldsWithoutTouch, 'otherReasonCheckbox'] as const;

export const checkboxFields = [
  'financialServices',
  'cardAccess',
  'businessRelationship',
  'creditBureauData',
] as const;

export const revokeCheckboxFields = [...checkboxFields, 'otherReasonCheckbox'] as const;
